/**
 * DatePicker — a lightweight date picker built on native HTML date inputs.
 *
 * Styled with Tailwind to match the existing design system.
 * A Radix Popover-based custom calendar can be substituted here
 * after installing @radix-ui/react-popover.
 */

interface DatePickerProps {
  label: string;
  value: string;        // ISO 8601 date string "YYYY-MM-DD"
  onChange: (value: string) => void;
  min?: string;         // ISO 8601 date string
  max?: string;         // ISO 8601 date string
  disabled?: boolean;
}

export function DatePicker({
  label,
  value,
  onChange,
  min,
  max,
  disabled = false,
}: DatePickerProps): JSX.Element {
  return (
    <div className="flex flex-col gap-1">
      <label className="text-sm font-medium text-gray-700">{label}</label>
      <input
        type="date"
        value={value}
        min={min}
        max={max}
        disabled={disabled}
        onChange={(e) => onChange(e.target.value)}
        style={{ colorScheme: 'light' }}
        className={[
          'w-full rounded-md border border-gray-300 bg-white px-3 py-2',
          'text-sm text-gray-900 shadow-sm',
          'focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500',
          disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer hover:border-gray-400',
        ].join(' ')}
      />
    </div>
  );
}
